import { Action } from "@ngrx/store";

export const SET_STATIC_PAGES = "[STATIC PAGES] Set Static Pages";

export const CLEAR_STATIC_PAGES = "[STATIC PAGES] Clear Static Pages";

export const SET_COOKIES_CONSENT_REOPEN_TIMESTAMP =
  "[STATIC PAGES] Set Cookies Consent Reopen Timestamp";

export class SetStaticPages implements Action {
  readonly type = SET_STATIC_PAGES;
  constructor(public payload: any) {}
}

export class ClearStaticPages implements Action {
  readonly type = CLEAR_STATIC_PAGES;
  constructor() {}
}

export class SetCookiesConsentReopenTimestamp implements Action {
  readonly type = SET_COOKIES_CONSENT_REOPEN_TIMESTAMP;
  constructor(public payload: any) {}
}

export type StaticPagesActions =
  | SetStaticPages
  | ClearStaticPages
  | SetCookiesConsentReopenTimestamp;
